function AddDevices({ setActiveComponent, org }) {
    return (
        <div className="midde_cont">
            <div className="container-fluid" style={{ paddingLeft: "0", paddingRight: "0" }} >
                <div className="row column_title">
                    <div className="col-md-12">
                        <div className="page_title">
                            <h2>Add Devices</h2>
                        </div>
                    </div>
                </div>
                <div className="row column1">
                    <div className="col-md-12">
                        <div className="white_shd full margin_bottom_30 add_devices_instruction_list_wrap">
                            <h4 className="add_devices_instruction_heading">
                                Adding a CareWindow is a simple, 3-step process. Follow the instructions below to add one or more CareWindows to the Admin Portal.
                            </h4>
                            <ol className="add_devices_instruction_list">
                                <li className="add_devices_instruction">
                                    On the CareWindow device, tap Pair, then tap "Link this device to the &nbsp;<i><b>Care</b>Window</i> &nbsp;Admin Portal".
                                </li>

                                <li className="add_devices_instruction">
                                    <label>
                                        In the text field that appears, enter your Admin Portal code:
                                        <b style={{ paddingLeft: "5px" }}>{org.code}</b> and PIN: <b>{org.pin}</b>.
                                    </label>
                                </li>

                                <li className="add_devices_instruction">
                                    <div>
                                        After you tap “Confirm”, your device should appear under
                                        <a href="#" onClick={() => setActiveComponent("Manage Devices")} className="link-primary" > Manage Devices </a>.
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default AddDevices;